import { MarketplaceModalHeader } from "@/src/components/Modal/ModalHeader";
import { useTimeoutEffect } from "@react-hookz/web";
import BaseMarketplaceModal, {
  Props as BaseMarketplaceModalProps,
} from "@/src/components/Modal/BaseMarketplaceModal";
import clsx from "clsx";

export type BaseActionModalProps = BaseMarketplaceModalProps & {
  title: React.ReactNode;
  // onClose should be used for setting the modal open to false and most scenarios
  // actionOnClose occurs after the modal closes and should only be used for special scenarios
  actionAfterClose?: () => void;
};

const BaseActionModal: React.FC<BaseActionModalProps> = ({
  isOpen,
  classes,
  onClose,
  actionAfterClose,
  children,
  title,
}) => {
  // Due to modal closing transition resetting MFA state must occur
  // a little after the closing transition has occurred
  useTimeoutEffect(
    () => {
      actionAfterClose && actionAfterClose();
    },
    !isOpen && actionAfterClose ? 300 : undefined,
  );

  return (
    <BaseMarketplaceModal
      isOpen={isOpen}
      onClose={onClose}
      classes={{
        ...classes,
        modal: clsx("border border-gray-425 md:w-[500px]", classes?.modal),
      }}
    >
      <div className={"flex h-full flex-col "}>
        <MarketplaceModalHeader
          onClose={onClose}
          classes={{
            outerDiv: "items-start md:items-center px-6 pt-6 md:px-9 md:pt-9",
          }}
        >
          {title}
        </MarketplaceModalHeader>

        {children}
      </div>
    </BaseMarketplaceModal>
  );
};

export default BaseActionModal;
